import React from 'react'
import styled from 'styled-components';
import { get } from 'lodash'
import { Image } from 'semantic-ui-react'

const Name = styled.div`
  line-height: 42px;
  display: block;
  font-size: 18px;
`;

const SummaryContainer = styled.div`
  margin-bottom: 22px;
`;

const Instructions = styled.div`
  color: #868686;
`;

const Location = styled.div`
  color: #868686;
`;


// TODO: add parcel machine name
export default class ShippingMethodSummary extends React.PureComponent {

  getActiveShippingMethod = () => {
    const { cart, shippingMethods } = this.props;

    return shippingMethods[cart.shipping_method];
  };

  getLocationName = () => {
    const { cart } = this.props;
    const shippingMethod = this.getActiveShippingMethod();

    if(shippingMethod && ['ShopSmartPostParcelMethod', 'ShopOmnivaParcelMethod', 'ShopDPDParcelMethod'].indexOf(shippingMethod.type) > -1) {
      return get(cart, 'shipping_method_options.place.name');
    }

    return null;
  };

  showInstructions = () => {
    const shippingMethod = this.getActiveShippingMethod();
    if(shippingMethod && ['ShopSmartPostParcelMethod', 'ShopOmnivaParcelMethod', 'ShopDPDParcelMethod'].indexOf(shippingMethod.type) > -1) {
      return false;
    }

    return !!shippingMethod.instructions;
  };

  render() {
    const { cart, shippingMethods } = this.props;

    if(cart && shippingMethods) {
      const shippingMethod = this.getActiveShippingMethod();
      const name = this.getLocationName();
      if(shippingMethod) {
        return (
          <SummaryContainer>
            <Name>{ shippingMethod.name }</Name>
            { name ? <Location>{ name }</Location> : null }
            { this.showInstructions() ?
              <Instructions>{ shippingMethod.instructions } </Instructions> : null
            }
          </SummaryContainer>
        )

      }
    }

    return null;
  }
}
